// Local source-logo map — the web client serves these itself instead of
// depending on backend-provided hotlinks (which broke for several sources).
const SOURCE_ICONS = {
  'newgar': '/images/sources/elite-reals.png',
  'olx': '/images/sources/olx.png',
  'aqarmap': '/images/sources/aqarmap.svg',
  'property-finder': '/images/sources/property-finder.svg',
  'bayut': '/images/sources/bayut.svg',
  'nawy': '/images/sources/nawy.svg'
}

export const AVATAR_PLACEHOLDER = '/images/sources/avatar.png'

export function sourceIcon(source) {
  return SOURCE_ICONS[source] || null
}

export function avatarFor(user, source) {
  user = user || {}
  // the stored picture is what the login provider gave us — prefer it over
  // a reconstructed Graph URL (which breaks for merged google+facebook
  // accounts and unauthenticated requests)
  if (user.profile_picture) return user.profile_picture
  if (user.facebook_id)
    return `https://graph.facebook.com/${user.facebook_id}/picture?type=normal`
  return AVATAR_PLACEHOLDER
}
